<!-- ─────────────────────────────────────────────────────────────────────── -->
<!-- Conversation Action Menu                                              -->
<!-- A shared <mat-menu> used by both single-conversation badges and the   -->
<!-- bulk action bar. The parent binds [matMenuTriggerFor]="conversationActionMenu.menu". -->
<!-- ─────────────────────────────────────────────────────────────────────── -->
<mat-menu #conversationMenu="matMenu" class="inbox-menu" panelClass="inbox-view-menu">

    <!-- ─── Classification Panel ───────────────────────────────────────── -->
    <ng-container *ngIf="activeMenu === CONVERSATION_MENU_OPTIONS.CATEGORY">
        <ng-container *ngFor="let category of categories">
            <button mat-menu-item (click)="updated.emit({ category: category.type })">
                <span>{{ category.name }}</span>
                <!-- Show check mark for currently-selected category (single mode only) -->
                <mat-icon *ngIf="activeConversation?.classification === category.type && updateType === 'single'">
                    check
                </mat-icon>
            </button>
        </ng-container>
    </ng-container>

    <!-- ─── Status Panel ───────────────────────────────────────────────── -->
    <ng-container *ngIf="activeMenu === CONVERSATION_MENU_OPTIONS.STATUS">
        <ng-container *ngFor="let status of statuses">
            <button mat-menu-item (click)="updated.emit({ status: status.type })">
                <span>{{ status.name }}</span>
                <!-- Show check mark for currently-selected status (single mode only) -->
                <mat-icon *ngIf="((activeConversation?.status === status.type) || (activeConversation?.status === null && status.type === 'new')) && updateType === 'single'">
                    check
                </mat-icon>
            </button>
        </ng-container>
    </ng-container>

    <!-- ─── Assign-To Panel ────────────────────────────────────────────── -->
    <div class="assigne-to-menu" *ngIf="activeMenu === CONVERSATION_MENU_OPTIONS.ASSIGN">
        <span class="title">{{ 'smart_inbox.inbox_view.action_menu.assign_to' | translate }}</span>

        <!-- User list -->
        <ng-container *ngFor="let user of users">
            <button mat-menu-item (click)="updateAssignee(user.id)">
                <span class="user-avatar" [style.backgroundColor]="getUserColor(user)">
                    {{ getUserInitials(user) }}
                </span>
                <span>{{ getUserFullname(user) }}</span>
                <!-- Show check mark for currently-assigned user (single mode only) -->
                <mat-icon *ngIf="activeConversation?.assignee?.id === user.id && updateType === 'single'">
                    check
                </mat-icon>
            </button>
        </ng-container>

        <hr class="separator" />

        <!-- Unassign option -->
        <button mat-menu-item (click)="updateAssignee(null)">
            <span>{{ 'smart_inbox.inbox_view.action_menu.unassign' | translate }}</span>
            <mat-icon *ngIf="!activeConversation?.assignee?.id && updateType === 'single'">
                check
            </mat-icon>
        </button>
    </div>

    <!-- ─── More Panel ───────────────────────────────────────────────────── -->
    <div class="more-menu" *ngIf="activeMenu === CONVERSATION_MENU_OPTIONS.MORE">
        <button mat-menu-item (click)="markAsUnread.emit()" [disabled]="!activeConversation?.is_read">
            <ui-svg-icon svgIcon="inbox" size="medium"></ui-svg-icon>
            <span>{{ 'smart_inbox.inbox_view.action_menu.mark_as_unread' | translate }}</span>
        </button>
    </div>
</mat-menu>
